export enum IncidentType {
  NEAR_DANGER = "Near Danger",
  DANGER = "Danger",
  DRONE_ALERT="Drone Alert",
}

export const formatIncidentType = (type: string): string => {
  return (IncidentType as Record<string, string>)[type] || type;
};
